import gql from 'graphql-tag';
import {destinationCarouselFragments as reactPropertyCarouselDestinationCarouselFragments} from '@homeaway/react-property-carousel';

const destinationCarouselFragments = {
    SearchResult: gql`
        fragment DestinationCarouselSearchResult on SearchResult {
            destinationRecommendationResponse(
                size: 8
                target: SERP_LARGE_SEARCH_TERM_DESTINATION
            ) {
                ...DestinationCarouselRecommendedDestinationResponse
            }
        }
        ${reactPropertyCarouselDestinationCarouselFragments.RecommendedDestinationResponse}
    `
};

export {destinationCarouselFragments};
